import { Card } from "antd";
import styled from "styled-components";

export const Wrapper = styled(Card)``;
